import { Select } from 'antd-v4'
import * as React from 'react'

export type monthType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12

export type TQuarterFirstMonth = Extract<monthType, 1 | 4 | 7 | 10>

interface IMonthOption {
  value: monthType
  label: string
}

const monthOptions: IMonthOption[] = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
]

const quarterOptions: IMonthOption[] = [
  { value: 1, label: 'January to March - Due April 8th' },
  { value: 4, label: 'April to June - Due July 8th' },
  { value: 7, label: 'July to September - Due October 8th' },
  { value: 10, label: 'October to December - Due January 8th' },
]

interface IProps {
  month: monthType
  isLabel?: boolean
  isQuarterSelector?: boolean
  onChange: (month: monthType) => void
}

export const MonthSelector: React.FC<IProps> = ({
  month,
  isLabel = true,
  isQuarterSelector = false,
  onChange,
}: IProps) => {
  return (
    <div className='form-group'>
      {isLabel && <label>Month</label>}
      <Select
        className='w-100'
        showSearch
        value={(month as number) === 0 ? undefined : month}
        placeholder={isQuarterSelector ? 'Select quarter...' : 'Select month...'}
        options={isQuarterSelector ? quarterOptions : monthOptions}
        onSelect={(value) => {
          onChange(value)
        }}
      />
    </div>
  )
}
